var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"\n    secondary--text\n    text--darken-1 text-h6 text-sm-h5 text-md-h4 text-uppercase\n    font-weight-bold\n  "},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }